import RestService from './RestService';

export default class CompanyAudit extends RestService {
    constructor(parentService, companyId) {
        if (parentService && companyId) {
            super(`${parentService.baseUrl}/${companyId}/audit`);
        } else {
            throw new Error('company is required');
        }
    }
}
